const motionDurationModerate = '0.4s';

export { motionDurationModerate };
